import { __ } from "@wordpress/i18n";
import { RichText } from "@wordpress/block-editor";
import { applyFilters } from "@wordpress/hooks";
import BlockContext from "../context/blockContext";
import { useContext } from "@wordpress/element";

export default function Contact({ section, index, }) {
    const { attributes, setAttributes, emailPhoneVisibility, updateField } = useContext(BlockContext);
    const { sectionItems } = attributes;
    return (
    <div className="cv-contact">
        {emailPhoneVisibility && (
            <>
                {section.showEmail && (
                    <div>
                        <strong>{__('Email', 'cv-builder')}: </strong>
                        <RichText
                            tagName="span"
                            value={section.email}
                            onChange={(value) => updateField(index, "email", value)}
                        />
                    </div>
                )}
                {section.showPhoneNumber && (
                    <div>
                        <strong>{__('Phone', 'cv-builder')}: </strong>
                        <RichText
                            tagName="span"
                            value={section.phoneNumber}
                            onChange={(value) => updateField(index, "phoneNumber", value)}
                        />
                    </div>
                )}
            </>
        )}
        {(section.showAddress && section.address) &&(
        <div>
            <strong>{__('Address', 'cv-builder')}: </strong>
            <RichText
            tagName="span"
            value={section.address}
            onChange={(value) => updateField(index, "address", value)}
            />
        </div>
        )}
        {(section.showWebsite && section.website) && (
        <div>
            <strong>{__('Website', 'cv-builder')}: </strong>
            <RichText
            tagName="span"
            value={section.website}
            onChange={(value) => updateField(index, "website", value)}
            />
        </div>
        )}
        {(section.showCity && section.city) && (
        <div>
            <strong>{__('City', 'cv-builder')}: </strong>
            <RichText
            tagName="span"
            value={section.city}
            onChange={(value) => updateField(index, "city", value)}
            />
        </div>
        )}
        {(section.showPostalCode && section.postalCode) && (
        <div>
            <strong>{__('Postal Code', 'cv-builder')}: </strong>
            <RichText
            tagName="span"
            value={section.postalCode}
            onChange={(value) => updateField(index, "postalCode", value)}
            />
        </div>
        )}
        {/* {sectionItems.map((section, index) => {
            const socialIconUnderContact = applyFilters('bwdcv.socialIconContact', null, {
                section,
                socialIcon: section.socialIcon,
                setAttributes,
                attributes
            });
            return (
                <div key={index} className="section">
                {socialIconUnderContact}
                </div>
            );
        })} */}
    </div>
);
}

